// Avatar images for the chat interface
// Using local image assets for better performance and customization

export const teacherAvatar = '/teacherPic.png'; // Custom teacher avatar image
export const userAvatar = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'; 